/**
 * useManagedSqlDbDetails Hook
 *
 * Custom React Query hook for fetching managed SQL database details.
 */

import { useQuery } from '@tanstack/react-query';
import { managedSqlDbService } from '../../../api/managed-sql-db.service';

/**
 * Hook for fetching managed SQL database details
 * @param tenantId - Tenant ID
 * @param managedSqlDbId - Managed SQL database ID
 */
export const useManagedSqlDbDetails = (tenantId: string, managedSqlDbId: string) => {
  return useQuery({
    queryKey: ['managedSqlDbs', tenantId, managedSqlDbId],
    queryFn: async () => {
      const result = await managedSqlDbService.getManagedSqlDb(tenantId, managedSqlDbId);
      return result;
    },
    enabled: !!tenantId && !!managedSqlDbId,
    staleTime: 30 * 1000, // 30 seconds (shorter due to status changes)
  });
};
